import ApiService from './../api/ApiService';
import Config from '../constants/Config';
import Airport from '../models/Airport';
import Urls from './../api/Urls';

export function getAirport(params) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRPORT_LIST,
        params: params,
        parser: airportsDataParser,
    }).get();
}

export function getAirportDetail(id) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRPORT_DETAIL,
        endpointParams: { id },
        parser: (data) => new Airport(data.data),
    }).get();
}

export function createAirportDetail(airport) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRPORT_ACTION,
        parser: (data) => new Airport(data.airport),
    }).post(airport.export());
}

export function updateAirportDetail(airport) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRPORT_ACTION,
        parser: (data) => new Airport(data.airport),
    }).put(airport.export());
}

export function deleteAirportDetail(airport) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRPORT_DETAIL,
        endpointParams: { id: airport.id }
    }).delete();
}

export function createAirportTranslate(airport) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRPORT_TRANSLATE_CREATE,
    }).post(airport.export(true).translate());
}

export function updateAirportTranslate(airport) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRPORT_TRANSLATE_UPDATE,
    }).put(airport.export(true).translate());
}

export function deleteAirportTranslate(id) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRPORT_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

export function getAirlineDomestic() {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRLINE_LIST_DOMESTIC
    }).get();
}

export function getAirportDeparture() {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRPORT_LIST_DEPARTURE
    }).get();
}

export function getAirportArrival() {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRPORT_LIST_ARRIVAL
    }).get();
}

const airportsDataParser = (data) => ({
    result: (data.data.result || []).map(item => new Airport(item)),
    pageIndex: data.data.pageIndex,
    pageSize: data.data.pageSize,
    totalCount: data.data.totalCount
})
export function getToAirportList(id) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.TOAIRPORT_LIST,
        endpointParams: { id },
        parser: data => data.data
    }).get();
}

export function createToAirportList(id, airportCodes) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.TOAIRPORT_LIST,
        endpointParams: { id },
    }).post(airportCodes);
}

export function updateToAirportList(id, airportCodes) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.TOAIRPORT_LIST,
        endpointParams: { id },
    }).put(airportCodes);
}

export function getAirlineSourceVJ() {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRLINE_SOURCE_VJ,
        parser: data => data.data
    }).get();
}
export function updateAirlineSource(params) {
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.AIRLINE_SOURCE_UPDATE,
    }).put(params);
}